/**
 * Localised risk labels for public views.
 *
 * The matrix legend and the detail views must show the same wording, so both
 * resolve through the shared display levels instead of the German-only
 * RISK_META labels (which stay in use for the admin area).
 */
import { RISK_TO_LEVEL, isInteractionRisk, type Level } from "@/lib/matrix-risk";
import type { StringKey } from "@/i18n/strings";

export function levelLabelKey(level: Level): StringKey {
  return `level.${level}` as StringKey;
}

/** Unknown or invalid values resolve to the neutral "unknown" label. */
export function riskLabelKey(risk: unknown): StringKey {
  const level: Level = isInteractionRisk(risk) ? RISK_TO_LEVEL[risk] : "unknown";
  return levelLabelKey(level);
}
